import { RUI_VIEW_PRIVATE_PROPS_KEY } from './constants';

export function genReducers() {
    return {
        // 内部参数传递reducer
        __saveRuiViewPrivatePropsSuccess__(state, { payload }) {
            return {
                ...state,
                [RUI_VIEW_PRIVATE_PROPS_KEY]: payload
            };
        }
    };
}
